

























































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { PopSettingsVO } from '@/model/FormWheel';
import { EMBEDDED_FIXED_WIDTH_DEFAULT } from '@/views/wheelOfFortune/constant/options';

@Component({
  name: 'EmbeddedPopup'
})
export default class EmbeddedPopup extends Vue {
  @Prop({ required: true }) formData!: PopSettingsVO;

  @Prop({ required: true }) activePageSetting!: string;

  @Prop(String) couponCopyText!: string;

  @Prop(Array)
  countryList!: any;

  selectedCountry = {
    countryAbbreviation: 'US',
    phoneCode: '+1'
  };

  get startOrEnd() {
    // 根据 activePageSetting 返回对应的表单数据
    if (this.activePageSetting === 'start') {
      return this.formData.start || [];
    } else if (this.activePageSetting === 'end') {
      return this.formData.end || [];
    } else if (this.activePageSetting === 'middle') {
      return this.formData.middle || [];
    }

    return this.formData.start || [];
  }

  // 当前页是否含自定义问题字段（决定提交按钮布局）
  get hasCustomField() {
    const list = this.startOrEnd || [];
    return list.some((i: any) => i.type === '自定义');
  }

  // 当前页的选项列数（start 用 optionColumns，middle 用 middleOptionColumns）
  get currentOptionColumns() {
    const rules: any = this.formData.rules || {};
    if (this.activePageSetting === 'middle') {
      return Math.max(1, Math.min(3, Number(rules.middleOptionColumns || 1)));
    }
    return Math.max(1, Math.min(3, Number(rules.optionColumns || 1)));
  }

  // 选项容器样式：按列数分列 + 应用选项间距配置
  get customOptionsStyle() {
    // 与普通弹窗一致：列间距 16px，行间距 8px
    return {
      display: 'flex',
      flexWrap: 'wrap',
      columnGap: '16px',
      rowGap: '8px',
      textAlign: 'left',
    };
  }

  // 单个选项样式：按列数算宽度 + 应用左右间距
  customOptionStyle() {
    // 与普通弹窗一致：1列 flex-basis 100%，多列 flex-basis auto（由 column-gap 控制间距）
    const cols = this.currentOptionColumns;
    return {
      flex: `0 0 ${cols === 1 ? '100%' : 'auto'}`,
      minWidth: '0',
      maxWidth: cols === 1 ? '100%' : `calc(${Math.floor(100 / cols)}% - ${Math.ceil(16 * (cols - 1) / cols)}px)`,
      margin: '0',
    };
  }

  // 字段间距（内联 style，确保生效）：按 data-form-type 读对应配置
  fieldMarginStyle(input: any) {
    const rules: any = this.formData.rules || {};
    const isMiddle = this.activePageSetting === 'middle';
    let top = 0, bottom = 14, left = 0, right = 0;
    if (input.type === '自定义') {
      if (input.questionType === 'Dropdown') {
        top = (isMiddle ? rules.middleDropdownMarginTop : rules.dropdownMarginTop) ?? 0;
        bottom = (isMiddle ? rules.middleDropdownMarginBottom : rules.dropdownMarginBottom) ?? 14;
        left = (isMiddle ? rules.middleDropdownMarginLeft : rules.dropdownMarginLeft) ?? 0;
        right = (isMiddle ? rules.middleDropdownMarginRight : rules.dropdownMarginRight) ?? 0;
      } else if (input.questionType === 'Date') {
        top = (isMiddle ? rules.middleInputMarginTop : rules.inputMarginTop) ?? 0;
        bottom = (isMiddle ? rules.middleInputMarginBottom : rules.inputMarginBottom) ?? 14;
        left = (isMiddle ? rules.middleInputMarginLeft : rules.inputMarginLeft) ?? 0;
        right = (isMiddle ? rules.middleInputMarginRight : rules.inputMarginRight) ?? 0;
      } else {
        top = (isMiddle ? rules.middleOptionMarginTop : rules.optionMarginTop) ?? 0;
        bottom = (isMiddle ? rules.middleOptionMarginBottom : rules.optionMarginBottom) ?? 14;
        left = (isMiddle ? rules.middleOptionMarginLeft : rules.optionMarginLeft) ?? 0;
        right = (isMiddle ? rules.middleOptionMarginRight : rules.optionMarginRight) ?? 0;
      }
    } else {
      // 邮箱/手机号
      top = (isMiddle ? rules.middleInputMarginTop : rules.inputMarginTop) ?? 0;
      bottom = (isMiddle ? rules.middleInputMarginBottom : rules.inputMarginBottom) ?? 14;
      left = (isMiddle ? rules.middleInputMarginLeft : rules.inputMarginLeft) ?? 0;
      right = (isMiddle ? rules.middleInputMarginRight : rules.inputMarginRight) ?? 0;
    }
    return {
      marginTop: `${top}px`,
      marginBottom: `${bottom}px`,
      marginLeft: `${left}px`,
      marginRight: `${right}px`,
    };
  }

  // 选项文字样式：字号/字体/颜色/行高（与 C 端对齐）
  get customOptionTextStyle() {
    const rules: any = this.formData.rules || {};
    if (this.activePageSetting === 'middle') {
      return {
        fontSize: rules.middleOptionFontSize || '14px',
        fontFamily: rules.middleOptionFontFamily,
        color: rules.middleOptionTextColor || rules.middleOptionColor || '#1D2129',
        lineHeight: '20px',
      };
    }
    return {
      fontSize: rules.optionFontSize || '14px',
      fontFamily: rules.optionFontFamily,
      color: rules.optionTextColor || rules.optionColor || '#1D2129',
      lineHeight: '20px',
    };
  }

  // 选框样式：未选中边框色 / 选中填充色
  get customMaskStyle() {
    const rules: any = this.formData.rules || {};
    // 选框边框固定 #C5C4CE，不随选项文字颜色变化（与 C 端一致）
    const borderColor = '#C5C4CE';
    const checkedColor = this.activePageSetting === 'middle' ? (rules.middleOptionBackground || '#1D2129') : (rules.optionBackground || '#1D2129');
    return { borderColor, checkedColor };
  }

  // 题目样式：颜色/字号/字体（单选多选用 optionTitle*，下拉用 dropdownTitle*）
  customTitleStyle(input: any) {
    const rules: any = this.formData.rules || {};
    if (input.questionType === 'Dropdown') {
      if (this.activePageSetting === 'middle') {
        return {
          color: rules.middleDropdownTitleColor || '#1D2129',
          fontSize: rules.middleDropdownTitleFontSize || '16px',
          fontWeight: 400,
          fontFamily: rules.middleDropdownTitleFontFamily,
          lineHeight: '22px',
          marginBottom: '12px',
        };
      }
      return {
        color: rules.dropdownTitleColor || '#1D2129',
        fontSize: rules.dropdownTitleFontSize || '16px',
        fontWeight: 400,
        fontFamily: rules.dropdownTitleFontFamily,
        lineHeight: '22px',
        marginBottom: '12px',
      };
    }
    if (this.activePageSetting === 'middle') {
      return {
        color: rules.middleOptionTitleColor,
        fontSize: `${rules.middleOptionTitleFontSize || 14}px`,
      };
    }
    return {
      color: rules.optionTitleColor || '#1D2129',
      fontSize: rules.optionTitleFontSize || '16px',
      fontWeight: 400,
      fontFamily: rules.optionFontFamily,
      lineHeight: '22px',
      marginBottom: '12px',
    };
  }

  // 下拉框间距：marginTop/Bottom/Left/Right
  get customDropdownMarginStyle() {
    const rules: any = this.formData.rules || {};
    const isMiddle = this.activePageSetting === 'middle';
    return {
      marginTop: `${(isMiddle ? rules.middleDropdownMarginTop : rules.dropdownMarginTop) ?? 0}px`,
      marginBottom: `${(isMiddle ? rules.middleDropdownMarginBottom : rules.dropdownMarginBottom) ?? 0}px`,
      marginLeft: `${(isMiddle ? rules.middleDropdownMarginLeft : rules.dropdownMarginLeft) ?? 0}px`,
      marginRight: `${(isMiddle ? rules.middleDropdownMarginRight : rules.dropdownMarginRight) ?? 0}px`,
    };
  }

  // 获取嵌入弹窗容器样式
  get embeddedPopupStyle() {
    const styleKeyMap: { [key: string]: string } = {
      start: 'cartx-b-show',
      middle: 'cartx-b-show__middle',
      end: 'cartx-b-show__end'
    };
    const styleKey = styleKeyMap[this.activePageSetting || 'start'];
    const style: any = {
      background: this.formData.styles.styleMap[styleKey]?.background || ''
    };
    // 【暂时隐藏】定宽模式：预览容器按客户填的像素值渲染——宽度跟随容器撑开即可
    // if (this.isFixedWidthMode) {
    //   style.width = this.fixedWidthPx + 'px';
    // }
    return style;
  }

  // 是否定宽模式
  get isFixedWidthMode() {
    return this.formData.rules.embeddedWidthMode === 'fixed';
  }

  // 定宽像素值
  get fixedWidthPx() {
    return this.formData.rules.embeddedFixedWidth || EMBEDDED_FIXED_WIDTH_DEFAULT;
  }

  // 底部提示文案（随宽度模式变化）
  get embeddedTipText() {
    // 【暂时隐藏】定宽文案——统一回到固定提示语
    // if (this.isFixedWidthMode) {
    //   return '将以固定宽度 ' + this.fixedWidthPx + 'px 渲染';
    // }
    return this.$tx('form.previewShownAt340pxBlock', '*以340px区块宽度进行示例展示，实际展示宽度依赖网站区块装修');
  }

  // 获取当前页面的标题文本
  get currentTitleText() {
    const titleMap: { [key: string]: string } = {
      start: this.formData.texts.topTitle || '',
      middle: this.formData.texts.middleTopTitle || '',
      end: this.formData.texts.endTopTitle || ''
    };
    return titleMap[this.activePageSetting] || '';
  }

  // 获取当前页面的标题样式键名
  get currentTitleStyleKey() {
    const styleKeyMap: { [key: string]: string } = {
      start: 'cartx-b-title',
      middle: 'cartx-b-title__middle',
      end: 'cartx-b-title-end'
    };
    return styleKeyMap[this.activePageSetting] || 'cartx-b-title';
  }

  // 获取当前页面的标题样式对象
  get currentTitleStyle() {
    const styleKey = this.currentTitleStyleKey;
    const styleMap = this.formData.styles.styleMap[styleKey] || {};

    return {
      color: styleMap.color,
      fontFamily: styleMap['font-family'],
      fontSize: styleMap['font-size'],
      textAlign: styleMap['text-align']
    };
  }

  // 获取当前页面的副标题文本
  get currentSubtitleText() {
    const textMap: { [key: string]: string } = {
      start: this.formData.texts.topSubTitle || '',
      middle: this.formData.texts.middleTopSubTitle || '',
      end: this.formData.texts.endTopSubTitle || ''
    };
    return textMap[this.activePageSetting] || '';
  }

  // 获取当前页面的副标题样式键名
  get currentSubtitleStyleKey() {
    const styleKeyMap: { [key: string]: string } = {
      start: 'cartx-b-subtitle',
      middle: 'cartx-b-subtitle__middle',
      end: 'cartx-b-subtitle-end'
    };
    return styleKeyMap[this.activePageSetting] || 'cartx-b-subtitle';
  }

  // 获取当前页面的副标题样式对象
  get currentSubtitleStyle() {
    const styleKey = this.currentSubtitleStyleKey;
    const styleMap = this.formData.styles.styleMap[styleKey] || {};

    return {
      color: styleMap.color,
      fontFamily: styleMap['font-family'],
      fontSize: styleMap['font-size'],
      textAlign: styleMap['text-align']
    };
  }

  // 获取当前页面的按钮样式键名
  get currentButtonStyleKey() {
    const styleKeyMap: { [key: string]: string } = {
      start: 'cartx-b-button',
      middle: 'cartx-b-button__middle',
      end: 'cartx-b-button-end'
    };
    return styleKeyMap[this.activePageSetting] || 'cartx-b-button';
  }

  // 获取当前页面的按钮链接
  get currentButtonUrl() {
    if (this.activePageSetting === 'start') {
      return this.formData.rules.buttonAction === 'link'
        ? this.defineUrl(this.formData.rules.openUrl)
        : 'javascript:void(0)';
    } else if (this.activePageSetting === 'middle') {
      // middle 页面的按钮逻辑，如果有 middleButtonAction 则使用，否则使用 start 的逻辑
      const middleButtonAction = (this.formData.rules as any).middleButtonAction || this.formData.rules.buttonAction;
      const middleOpenUrl = (this.formData.rules as any).middleOpenUrl || this.formData.rules.openUrl;
      return middleButtonAction === 'link' ? this.defineUrl(middleOpenUrl) : 'javascript:void(0)';
    } else {
      return this.formData.rules.endButtonAction === 'link'
        ? this.defineUrl(this.formData.rules.endOpenUrl)
        : 'javascript:void(0)';
    }
  }

  // 获取当前页面的按钮文本
  get currentButtonText() {
    if (this.activePageSetting === 'start') {
      return this.formData.texts.mainButton;
    } else if (this.activePageSetting === 'middle') {
      return (this.formData.texts as any).middleMainButton || this.formData.texts.mainButton;
    } else {
      // end 页面，暂时不处理 subscribeStatus，因为 embeddedPopupNew 可能不需要
      return this.formData.texts.endMainButton;
    }
  }

  // 获取当前页面的按钮样式对象
  get currentButtonStyle() {
    const buttonStyleKey = this.currentButtonStyleKey;
    const buttonStyleMap = this.formData.styles.styleMap[buttonStyleKey] || {};

    // 获取 show 下的按钮样式（优先级更高）
    const showButtonStyleKeyMap: { [key: string]: string } = {
      start: 'cartx-b-show .cartx-b-button',
      middle: 'cartx-b-show .cartx-b-button__middle',
      end: 'cartx-b-show .cartx-b-button-end'
    };
    const showButtonStyleKey = showButtonStyleKeyMap[this.activePageSetting] || 'cartx-b-show .cartx-b-button';
    const showButtonStyleMap = this.formData.styles.styleMap[showButtonStyleKey] || {};

    return {
      color: buttonStyleMap.color,
      fontFamily: buttonStyleMap['font-family'],
      background: showButtonStyleMap.background || buttonStyleMap.background,
      borderStyle: buttonStyleMap['border-style'],
      borderColor: buttonStyleMap['border-color'],
      borderRadius: buttonStyleMap['border-radius']
    };
  }

  get currentCouponCode() {
    if (this.formData.discountType === 'dongtai' || !!this.formData.discount) {
      return this.$tx('form.edit.field.dynamicShowCoupon', '动态显示折扣码');
    }
    const couponCode = this.formData.rules.couponCode || 'coupon code';
    return couponCode;
  }

  get currentCouponCopy() {
    return this.couponCopyText || 'Copy';
  }

  mounted() {
    // console.log(this.formData);
  }

  @Watch('formData', { deep: true })
  onFormDataChange(newVal: PopSettingsVO) {
    // console.log(newVal);
  }

  changeCountryCode(v) {
    this.selectedCountry.phoneCode = v.phoneCode;
    this.selectedCountry.countryAbbreviation = v.countryAbbreviation;
  }

  // 获取当前页面隐私文案颜色（按页面隔离）
  get currentPrivacyColor() {
    const styleMap = this.formData.styles.styleMap;
    if (this.activePageSetting === 'middle') {
      return styleMap['cartx-b-privacy__middle']?.['color'];
    }
    return styleMap['cartx-b-privacy']?.['color'];
  }

  // 获取当前页面的输入框类型
  get currentInputType() {
    const rules = this.formData.rules;
    if (this.activePageSetting === 'middle') {
      return (rules as any).middleInputType || rules.inputType;
    }
    return rules.inputType;
  }

  // 获取当前页面的输入框边框样式
  get currentInputBorderStyle() {
    const rules = this.formData.rules;
    if (this.activePageSetting === 'middle') {
      return (rules as any).middleInputBorderStyle || rules.inputBorderStyle;
    }
    return rules.inputBorderStyle;
  }

  // 获取当前页面的输入框边框颜色
  get currentInputBorderColor() {
    const rules = this.formData.rules;
    if (this.activePageSetting === 'middle') {
      return (rules as any).middleInputBorderColor || rules.inputBorderColor;
    }
    return rules.inputBorderColor;
  }

  // 获取当前页面的输入框圆角
  get currentInputBorderRadius() {
    const rules = this.formData.rules;
    if (this.activePageSetting === 'middle') {
      return (rules as any).middleInputBorderRadius || rules.inputBorderRadius;
    }
    return rules.inputBorderRadius;
  }

  // 获取当前页面的输入框背景显示方式
  get currentInputBackgroundShow() {
    const rules = this.formData.rules;
    if (this.activePageSetting === 'middle') {
      return (rules as any).middleInputBackgroundShow !== undefined
        ? (rules as any).middleInputBackgroundShow
        : rules.inputBackgroundShow;
    }
    return rules.inputBackgroundShow;
  }

  // 获取当前页面的输入框背景颜色
  get currentInputBackground() {
    const rules = this.formData.rules;
    if (this.activePageSetting === 'middle') {
      return (rules as any).middleInputBackground || rules.inputBackground;
    }
    return rules.inputBackground;
  }

  // 获取当前页面的输入框文字颜色
  get currentInputColor() {
    const rules = this.formData.rules;
    if (this.activePageSetting === 'middle') {
      return (rules as any).middleInputColor || rules.inputColor;
    }
    return rules.inputColor;
  }

  // 下拉框文字样式：placeholder 颜色用 inputColor + opacity .3（与 C 端一致）
  get dropdownTextStyle() {
    return {
      color: this.currentInputColor,
      opacity: 0.3,
    };
  }

  get formStyle() {
    const inputType = this.currentInputType;
    const borderStyle = this.currentInputBorderStyle;
    const borderColor = this.currentInputBorderColor;
    const borderRadius = this.currentInputBorderRadius;
    const backgroundShow = this.currentInputBackgroundShow;
    const background = this.currentInputBackground;
    const inputColor = this.currentInputColor;

    const rules: any = this.formData.rules || {};
    const isMiddle = this.activePageSetting === 'middle';
    return `
      /* 字段间距：单选/多选用 optionMargin*，下拉用 dropdownMargin*，输入类用 inputMargin*（与普通弹窗一致）*/
      .cartx-embedded-form-wrapper[data-form-type="options"] {
        margin-top: ${(isMiddle ? rules.middleOptionMarginTop : rules.optionMarginTop) ?? 0}px !important;
        margin-bottom: ${(isMiddle ? rules.middleOptionMarginBottom : rules.optionMarginBottom) ?? 14}px !important;
        margin-left: ${(isMiddle ? rules.middleOptionMarginLeft : rules.optionMarginLeft) ?? 0}px !important;
        margin-right: ${(isMiddle ? rules.middleOptionMarginRight : rules.optionMarginRight) ?? 0}px !important;
      }
      .cartx-embedded-form-wrapper[data-form-type="dropdown"] {
        margin-top: ${(isMiddle ? rules.middleDropdownMarginTop : rules.dropdownMarginTop) ?? 0}px !important;
        margin-bottom: ${(isMiddle ? rules.middleDropdownMarginBottom : rules.dropdownMarginBottom) ?? 14}px !important;
        margin-left: ${(isMiddle ? rules.middleDropdownMarginLeft : rules.dropdownMarginLeft) ?? 0}px !important;
        margin-right: ${(isMiddle ? rules.middleDropdownMarginRight : rules.dropdownMarginRight) ?? 0}px !important;
      }
      .cartx-embedded-form-wrapper[data-form-type="input"] {
        margin-top: ${(isMiddle ? rules.middleInputMarginTop : rules.inputMarginTop) ?? 0}px !important;
        margin-bottom: ${(isMiddle ? rules.middleInputMarginBottom : rules.inputMarginBottom) ?? 14}px !important;
        margin-left: ${(isMiddle ? rules.middleInputMarginLeft : rules.inputMarginLeft) ?? 0}px !important;
        margin-right: ${(isMiddle ? rules.middleInputMarginRight : rules.inputMarginRight) ?? 0}px !important;
      }
      .cartx-embedded-form .cartx-embedded-form-input,
      .cartx-embedded-custom-input {
        border-width: ${inputType === 'bottom' ? '0 0 1px 0' : '1px'} !important;
        border-style: ${borderStyle} !important;
        border-color: ${borderColor} !important;
        border-radius: ${borderRadius} !important;
        background: ${backgroundShow !== 'none' ? background : 'none'} !important;
        color: ${inputColor} !important;
      }
      .cartx-embedded-custom-select {
        border-width: 1px !important;
        border-style: ${rules.dropdownBorderStyle || 'solid'} !important;
        border-color: ${rules.dropdownBorderColor || '#C5C4CE'} !important;
        border-radius: ${rules.dropdownBorderRadius || '4px'} !important;
        background: ${rules.dropdownBackgroundType !== 'none' ? (rules.dropdownBackgroundColor || '#FFFFFF') : 'none'} !important;
      }
      .cartx-embedded-form input::-webkit-input-placeholder {
        color: ${inputColor} !important;
        opacity: .3;
      }
      .cartx-embedded-form input:-moz-placeholder {
        color: ${inputColor} !important;
        opacity: .3;
      }
      .cartx-embedded-form input::-moz-placeholder {
        color: ${inputColor} !important;
        opacity: .3;
      }
      .cartx-embedded-form input:-ms-input-placeholder {
        color: ${inputColor} !important;
        opacity: .3;
      }
      /* 手机号采集表单样式适配 */
      .cartx-embedded-form-input-mobile-number.el-input {
        border-width: ${inputType === 'bottom' ? '0 0 1px 0' : '1px'} !important;
        border-style: ${borderStyle} !important;
        border-color: ${borderColor} !important;
        border-radius: ${borderRadius} !important;
        overflow: hidden;
      }
      /* 清除手机号内部元素的默认 border，避免多层边框叠加 */
      .cartx-embedded-form-input-mobile-number .el-input-group__prepend,
      .cartx-embedded-form-input-mobile-number .el-input__inner,
      .cartx-embedded-form-input-mobile-number .el-select .el-input,
      .cartx-embedded-form-input-mobile-number .el-select .el-input__inner {
        border: none !important;
        background: transparent !important;
      }
      .cartx-embedded-form-input-mobile-number .el-input-group__prepend {
        background: transparent !important;
        border-right: none !important;
      }
      .cartx-embedded-form-input-mobile-number .el-input__inner {
        color: ${inputColor} !important;
      }
      .cartx-embedded-form-input-mobile-number .el-input__inner::-webkit-input-placeholder {
        color: ${inputColor} !important;
        opacity: .3;
      }
      .cartx-embedded-form-input-mobile-number .el-input__inner:-moz-placeholder {
        color: ${inputColor} !important;
        opacity: .3;
      }
      .cartx-embedded-form-input-mobile-number .el-input__inner::-moz-placeholder {
        color: ${inputColor} !important;
        opacity: .3;
      }
      .cartx-embedded-form-input-mobile-number .el-input__inner:-ms-input-placeholder {
        color: ${inputColor} !important;
        opacity: .3;
      }
    `;
  }

  defineUrl(url?: string) {
    if (url?.indexOf('https://') == -1 && url?.indexOf('http://') == -1) {
      return 'http://' + url;
    } else {
      return url;
    }
  }
}
